const mathcPath = (history, path) => {
  if (history.pathname.includes(path)) {
    return true;
  }

  return false;
};

const genrateDownloadLink = (filename) => {
  const extension = filename.trim().split(".").pop().toLowerCase();

  const mimeTypes = {
    // Documents
    pdf: "application/pdf",
    doc: "application/msword",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",

    // Excel
    xls: "application/vnd.ms-excel",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",

    // Images
    jpg: "image/jpeg",
    jpeg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    bmp: "image/bmp",
    webp: "image/webp",
    svg: "image/svg+xml",
    tif: "image/tiff",
    tiff: "image/tiff",
    ico: "image/x-icon",
    avif: "image/avif",

    // Optional additional formats
    txt: "text/plain",
    csv: "text/csv",
    json: "application/json",
    xml: "application/xml",
    zip: "application/zip",
  };

  return mimeTypes[extension]
    ? `data:${mimeTypes[extension]};base64,`
    : "";
};

const calculateAmmount = (ammount) => {
  if (ammount) {
    const amt = Number(parseFloat(ammount).toFixed(2)).toLocaleString("en", {
      minimumFractionDigits: 2,
    });
    return amt;
  }

  return "N/A";
};

function formatDateTime(dateTime) {
  if (!dateTime) return "N/A"; // Handle null or undefined values

  const dateObj = new Date(dateTime);
  if (isNaN(dateObj)) return "Invalid Date"; // Handle invalid date strings

  const year = String(dateObj.getFullYear()).slice(-2); // Get last two digits of year
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const date = String(dateObj.getDate()).padStart(2, "0");
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  return `${date}/${month}/${year} ${hours}:${minutes}`;
}

const getTimeDifferenceFromStartOfMonth = (datetimeStr) => {
  if (!datetimeStr) return null;

  const pickup = new Date(datetimeStr);
  if (isNaN(pickup)) return null;

  const startOfMonth = new Date(
    pickup.getFullYear(),
    pickup.getMonth(),
    1,
    0,
    0,
    0
  );
  const diffInMinutes = Math.floor((pickup - startOfMonth) / 60000);

  const hours = String(Math.floor(diffInMinutes / 60)).padStart(2, "0");
  const minutes = String(diffInMinutes % 60).padStart(2, "0");

  return `${hours}:${minutes}`;
};

export {
  mathcPath,
  genrateDownloadLink,
  calculateAmmount,
  formatDateTime,
  getTimeDifferenceFromStartOfMonth,
};
